import { render, staticRenderFns } from "./ThePartnerSettingList.vue?vue&type=template&id=55cc8b51&scoped=true"
import script from "./ThePartnerSettingList.vue?vue&type=script&lang=ts"
export * from "./ThePartnerSettingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cc8b51",
  null
  
)

export default component.exports